/**
 * Ethereum icon SVG component
 * Standard Ethereum diamond logo
 */
export function EthereumIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_434_2509)">
        <path
          d="M7.96326 11.9795L3.05176 9.08099L7.96026 16.0005L12.8743 9.08099L7.96026 11.9795H7.96326ZM8.03626 0L3.12676 8.14849L8.03626 11.052L12.9478 8.15149L8.03626 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_434_2509">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
